import base from "./base";
import { addErrorNotification } from "../utils/notifications";

base.options = {
	headers: {
		"Content-Type": "multipart/form-data"
	}
};
export const postApplication = (slug, formData) => {
	return base.post("/position/" + slug, formData);
};

export const postOpenApplication = formData =>
	base.post("/open-application", formData);



// WEBPACK FOOTER //
// ./src/services/submitApplication.js